import axios from "axios";

export const baseURL = "https://castle-auction-production.up.railway.app/api/";
// export const baseURL = "http://192.168.18.134:8080/api/";

// export const token = localStorage.getItem('accounting_company_sass_token');

export const axiosInstance = axios.create({
  baseURL: baseURL,
  timeout: 10000, // 10 seconds timeout
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("auction_portal");
    console.log('Axios request interceptor - Token:', token ? 'Present' : 'Missing');
    if (token) {
      config.headers["x-auth-token"] = token;
      console.log('Token added to headers:', config.headers["x-auth-token"]);
    } else {
      console.warn('No token found in localStorage');
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor to handle token expiration
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      console.error('Token expired or invalid - clearing localStorage');
      localStorage.removeItem("auction_portal");
      // You might want to redirect to login here
      window.location.href = '/auth/login';
    }
    return Promise.reject(error);
  }
);
